import { c as _c } from "react/compiler-runtime";
import OddsIcon from '@svenskaspelab/ui/react/icons/Odds';

/**
 * Renders an empty state when there are no betoffers available for a match.
 *
 * @returns Component
 */
function EmptyState() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="theme-oddset-light bg-surface text-surface-fg flex flex-col items-center justify-center"><OddsIcon fontSize={200} /><span className="text-2xl font-bold">Just nu har vi inga odds på den här matchen.</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default EmptyState;